module.exports = "<app-navbar></app-navbar>\n<section id=\"content\">\n  <div class=\"container content wrapper\">\n    <div class=\"sticky-top\">\n      <flash-messages></flash-messages>\n    </div>\n    <router-outlet></router-outlet>\n  </div>\n</section>\n<app-footer></app-footer>   \n<!-- <div class=\"container\" style=\"background:blue;\"> -->\n  <!-- <flash-messages></flash-messages> -->\n\n<!-- </div> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main